module.exports = __webpack_public_path__ + "assets/6cda58f2960ed9a40278ee47aa29ae87.mp3";